import { create } from 'zustand';

// Key for localStorage
const VARIETY_SWITCH_STATUS_KEY = 'variety_switch_status';

// Helper to get current status from localStorage
const getStoredStatus = () => {
  try {
    const storedStatus = localStorage.getItem(VARIETY_SWITCH_STATUS_KEY);
    return storedStatus || null;
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return null;
  }
};

// Helper to update localStorage
const updateStoredStatus = (status) => {
  try {
    localStorage.setItem(VARIETY_SWITCH_STATUS_KEY, status);
  } catch (error) {
    console.error('Error updating localStorage:', error);
  }
};

const useVarietySwitchStore = create((set) => ({
  // Initial state based on localStorage or null if first time
  status: getStoredStatus(),

  // Set status to 'switching'
  setStatusSwitching: () => {
    set({ status: 'switching' });
    updateStoredStatus('switching');
  },

  // Set status to 'done'
  setStatusDone: () => {
    set({ status: 'done' });
    updateStoredStatus('done');
  },

  // Reset status for testing
  resetStatus: () => {
    set({ status: null });
    try {
      localStorage.removeItem(VARIETY_SWITCH_STATUS_KEY);
    } catch (error) {
      console.error('Error resetting localStorage:', error);
    }
  }
}));

export default useVarietySwitchStore; 